/**
 * Leadtime resource loader. Used to dynamicaly load leadtime strings into cached assets.
 * issue: https://rituals.atlassian.net/browse/DL-16479
 */
'use strict';

const leadtimePlaceholderEl = '.js-load-leatime';

function loadLeadtime() {
    const leadtimePlaceholders = $(leadtimePlaceholderEl);
    if (!leadtimePlaceholders.length) {
        return;
    }

    leadtimePlaceholders.each(function (i, placeholderEl) {
        const $placeholderEl = $(placeholderEl);
        const resourceId = $placeholderEl.data('resourceid');
        if (!resourceId) {
            return;
        }

        $.ajax({
            type: 'GET',
            url: Urls.leadtimeGetByResourceId,
            data: {
                rid: resourceId
            },
            success: function (data) {
                if (!data) {
                    return;
                }

                $placeholderEl.replaceWith(data);
            }
        });
    });
}

const leadtime = {
    init: loadLeadtime
};

module.exports = leadtime;
